/**
 * Client-side email service for sending ROI reports
 */

import { getFunctions, httpsCallable } from 'firebase/functions';

export interface EmailFormData {
  recipientEmail: string;
  recipientName?: string;
  ccEmail?: string;
  personalMessage?: string;
  senderName?: string;
  sessionId: string;
  userEmail?: string;  // Email of the user who created the session (for locating data)
  reportUrl?: string;  // Direct URL to the report
  formData?: any;  // Complete form data for accurate email content
  results?: any;  // Complete calculation results
  enhancedData?: any;  // Enhanced ROI and savings data
}

export interface EmailResult {
  success: boolean;
  messageId?: string;
  message?: string;
  error?: string;
}

/**
 * Send ROI report email via Cloud Function
 */
export const sendROIReportEmail = async (data: EmailFormData): Promise<EmailResult> => {
  try {
    const functions = getFunctions();
    const sendEmail = httpsCallable(functions, 'sendROIReportEmail');
    
    const result = await sendEmail(data);
    const response = result.data as EmailResult;
    
    return response;
  } catch (error: any) {
    console.error('Error sending email:', error);
    
    // Extract error message from Firebase Functions error
    let errorMessage = 'Failed to send email';
    if (error.code === 'functions/invalid-argument') {
      errorMessage = error.message;
    } else if (error.code === 'functions/internal') {
      errorMessage = error.message || 'Server error occurred';
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    return {
      success: false,
      error: errorMessage
    };
  }
};